import React from 'react';
import StockReturnListFunctional from './components/stock-return-list-functional';
import './stock-return-list.scss';

const StockReturnList = () => {
	return <StockReturnListFunctional />;
};

export default StockReturnList;
